import { slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';

/* ----------------------- useForceUpdate ----------------------- */
var useForceUpdate = function useForceUpdate() {
  var _React$useState = React.useState(),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    updateState = _React$useState2[1];
  var forceUpdate = React.useCallback(function () {
    return updateState({});
  }, []);
  return forceUpdate;
};

export { useForceUpdate };
